import { createFileRoute } from '@tanstack/react-router';
import { NewQuotation } from '@/features/quotations/NewQuotation';

export const Route = createFileRoute('/_shell/quotations/new')({
  component: NewQuotation,
});
